import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';


const HeaderContainer = styled.header`
  height: 60px;
  background-color: ${({ theme }) => theme.headerBg};
  color: ${({ theme }) => theme.text};
  border-bottom: 1px solid #ddd;
  display: flex;
  align-items: center;
  padding: 0 24px;
  justify-content: space-between;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  position: fixed;
  top: 0;
   left: ${({ sidebarOpen }) => (sidebarOpen ? '270px' : '60px')};
  // width: ${({ sidebarOpen }) => (sidebarOpen ? 'calc(100% - 270px)' : 'calc(100% - 60px)')};
  right: 0;
  z-index: 1000;
   border-radius: 10px;

`;

const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
`;

const HeaderNav = styled.nav`
  display: flex;
  gap: 16px;
  align-items: center;
`;

const HeaderLink = styled(Link)`
  text-decoration: none;
  font-weight: 600;
  padding: 6px 10px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
  color: ${({ theme }) => theme.link};
  &:hover {
    background-color: ${({ theme }) => theme.linkHover};
  }
`;

const ToggleButton = styled.button`
  background: ${({ theme }) => theme.buttonBg};
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  color: ${({ theme }) => theme.text};
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;

 &:hover {
    background-color: ${({ theme }) => theme.buttonHoverBg};
}
`;

export default function Header({ darkMode, toggleDarkMode, sidebarOpen  }) {
  return (
    <HeaderContainer darkMode={darkMode} sidebarOpen={sidebarOpen}>
      <Title>Epidemiological Surveys - Canadian Beef Cattle Study</Title>
      <HeaderNav>
        <HeaderLink to="/" darkMode={darkMode}>Home</HeaderLink>
        {/* <HeaderLink to="/about" darkMode={darkMode}>About</HeaderLink> */}
        <ToggleButton onClick={toggleDarkMode} darkMode={darkMode}>
          {darkMode ? 'Light Mode' : 'Dark Mode'}
        </ToggleButton>
      </HeaderNav>
    </HeaderContainer>
  );
}